module.exports = __webpack_public_path__ + "static/media/16.8c058f6a.jpg";